import React, { Component } from "react";
import { selectAllLanguages } from "../redux/country/country.selector";
import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";
import Table from "./tableComponent/table";
import LanguageDeleteBtn from "./tableComponent/languageDeleteBtn";
import { selectLoadingStatus } from "./../redux/country/country.selector";
import WithSpinner from "./withSpinner";
import TableUpdateButton from "./tableComponent/tableUpdateButton";

class LanguagesTable extends Component {
  columns = [
    { title: "Country name", path: "countryName" },
    { title: "Language", path: "language" },
    { title: "Added By", path: "addedBy" },
    { title: "Added On", path: "addedOn" },
    {
      title: "Update Language",
      buttons: (user) => (
        <TableUpdateButton user={user} label="Update" route="add-language" />
      ),
      className: "tc-center",
    },
    {
      title: "Delete Language",
      buttons: (language) => (
        <LanguageDeleteBtn language={language} label="Delete" />
      ),
      className: "tc-center",
    },
  ];
  render() {
    const { languages, isLoading } = this.props;
    return isLoading ? (
      <WithSpinner />
    ) : (
      <React.Fragment>
        <Table
          elements={languages}
          columns={this.columns}
          title="All languages"
        />
      </React.Fragment>
    );
  }
}

const mapStateToProps = createStructuredSelector({
  languages: selectAllLanguages,
  isLoading: selectLoadingStatus,
});

export default connect(mapStateToProps)(LanguagesTable);
